export default __webpack_public_path__ + "static/media/connect.e81af1da.svg";